import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarTab } from "./Sidebar";
import LockerRoomIcon from "../../components/ui/icons/LockerRoomIcon";
import IndividualResultsIcon from "../../components/ui/icons/IndividualResultsIcon";
import AccountSettingsIcon from "../../components/ui/icons/AccountSettingsIcon";
import useSurvey from "../../features/survey/hooks/useSurvey";

interface MobileNavItem {
  id: SidebarTab;
  label: string;
  href: string;
  Icon: React.FC<{ active?: boolean }>;
}

const MobileNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isCompleted } = useSurvey();

  const MOBILE_NAV_ITEMS: MobileNavItem[] = [
    {
      id: "locker-room",
      label: "Locker Room",
      href: "/locker-room",
      Icon: LockerRoomIcon,
    },

    {
      id: "account-settings",
      label: "Account Settings",
      href: "/account-settings",
      Icon: AccountSettingsIcon,
    },
  ];

  if (isCompleted) {
    MOBILE_NAV_ITEMS.splice(1, 0, {
      id: "individual-results",
      label: "Individual Results",
      href: "/individual-results",
      Icon: IndividualResultsIcon,
    });
  }

  const activeTab = MOBILE_NAV_ITEMS.find((t) =>
    location.pathname.startsWith(t.href),
  )?.id;

  return (
    <>
      <nav className="mobile-nav">
        {MOBILE_NAV_ITEMS.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.href)}
              className="relative flex-1 flex flex-col items-center justify-center gap-1 py-2 border-none bg-transparent cursor-pointer"
              style={{
                color: isActive ? "#26295e" : "#9ba5b4",
                minHeight: 60,
                transition: "color 0.15s",
              }}
            >
              <div
                className="absolute top-0 left-1/2 -translate-x-1/2 rounded-b-full"
                style={{
                  height: 3,
                  width: isActive ? 32 : 0,
                  background: "#3b519c",
                  opacity: isActive ? 1 : 0,
                  transition: "width 0.2s, opacity 0.2s",
                }}
              />
              <div
                style={{
                  transform: isActive ? "translateY(-1px)" : "none",
                  transition: "transform 0.15s",
                }}
              >
                <item.Icon active={isActive} />
              </div>
              <span
                style={{
                  fontSize: 10,
                  fontFamily: "var(--font-primary)",
                  fontWeight: isActive ? 700 : 500,
                  lineHeight: 1,
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>
      <div
        className="mobile-nav-spacer"
        style={{ height: 64, flexShrink: 0 }}
      />
    </>
  );
};

export default MobileNav;
